import React from "react";
import Audio from "./Audio";
import Publication from "./Publication";
import Video from "./Video";
import News from "./News";
import Latest from "./Latest";

export default function LandingPage() {
  return (
    <div className="bg-body">
      <Latest />
      <Video />
      <Publication />
      <News />
      <Audio />
    </div>
  );
}
